import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/icons/logo.svg";
import { useTranslation } from "react-i18next";
import "./Menu.css";
import { FaGlobe } from "react-icons/fa";

const MobileMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang);
  };

  const handleNavClick = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/");

      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="mobile-menu-container">
      <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </button>

      <img className="logo" src={logo} />

      {menuOpen && (
        <ul className="mobile-menu">
          <div className="nav-links">
            <a onClick={() => handleNavClick("home")}>{t("home")}</a>
            <a onClick={() => handleNavClick("investments")}>
              {t("investments")}
            </a>
            <a onClick={() => handleNavClick("qualifications")}>
              {t("qualifications")}
            </a>
            <a onClick={() => handleNavClick("achievements")}>
              {t("achievements")}
            </a>
            <a onClick={() => handleNavClick("resume")}>{t("resume")}</a>
            <a onClick={() => navigate("/gallery")}>{t("gallery")}</a>
            <button
              className="investBtn-menu"
              onClick={() => navigate("/investmentRequest")}
            >
              {t("request_invest")}
            </button>

            <button
              onClick={toggleLanguage}
              className="languageBtn"
              aria-label={
                i18n.language === "en"
                  ? "Switch to Arabic"
                  : "Switch to English"
              }
              title={
                i18n.language === "en"
                  ? "Switch to Arabic"
                  : "Switch to English"
              }
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              {i18n.language === "en" ? "ع" : "EN"}
              <FaGlobe className="language-icon" />
            </button>
          </div>
        </ul>
      )}
    </div>
  );
};

export default MobileMenu;
